var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape15 = function SvgShape15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.947 68.617C.947 31.244 32.76.947 72 .947s71.052 30.297 71.052 67.67l.001 47.368c0 14.949-12.725 27.068-28.422 27.068-4.652 0-9.043-1.065-12.92-2.953-1.975-.961-3.946-2.016-5.925-3.074-6.964-3.726-14.032-7.507-21.764-7.507h-4.045c-7.731 0-14.799 3.781-21.764 7.507-1.979 1.058-3.95 2.113-5.925 3.074-3.876 1.888-8.267 2.953-12.92 2.953-15.696 0-28.42-12.119-28.42-27.068z",
    opacity: 0.1
  })));
};
export default SvgShape15;